import type { PlatformSettings } from '@/types/settings.types';

import { apiClient } from './api.service';

export const settingsApi = {
  get: (): Promise<PlatformSettings> =>
    apiClient.get<PlatformSettings>('/admin/settings').then((r) => r.data),

  update: (body: PlatformSettings): Promise<PlatformSettings> =>
    apiClient.patch<PlatformSettings>('/admin/settings', body).then((r) => r.data),
};
